window.addEventListener('DOMContentLoaded', function(e) {
    let btn = document.querySelector('.recent-news .btn.load-more');
    if (btn) {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            btn.previousElementSibling.querySelector('.slider-track').classList.add('show-all');
            btn.setAttribute('style', 'display: none;');
        })
    }
})